<div class="bg-pale">
  <nwx-discounts
    [discounts]="(discounts$ | async) || []"
    [products]="(products$ | async) || []"
    [allDiscounts]="(allDiscounts$ | async) || []"
  ></nwx-discounts>
</div>
